var React = require('react');

function OvalInner (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("circle",{"id":"path-111","cx":"1205.5","cy":"2302.5","r":"198.5","key":0}),React.createElement("mask",{"id":"mask-222","maskContentUnits":"userSpaceOnUse","maskUnits":"objectBoundingBox","x":"0","y":"0","width":"397","height":"397","fill":"white","key":1},React.createElement("use",{"xlinkHref":"#path-111"}))]),React.createElement("g",{"id":"Pages","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.502234323","strokeDasharray":"20","key":1},React.createElement("g",{"id":"Desktop-HD","transform":"translate(-1007.000000, -2104.000000)","stroke":"#979797","strokeWidth":"2"},React.createElement("use",{"id":"Oval-Copy","mask":"url(#mask-222)","xlinkHref":"#path-111"})))]);
}

OvalInner.defaultProps = {"width":"397px","height":"397px","viewBox":"0 0 397 397","version":"1.1"};

module.exports = OvalInner;

OvalInner.default = OvalInner;
